import React from 'react';
import { css, FontIcon } from '@fluentui/react';
import { valueOrDefaultColumnRenderer } from '../../../../Utilities';
export var DataGridColumnIconTextBase = function (props) {
    var text = props.text, icon = props.icon, dataGridColumnProcessedStyle = props.dataGridColumnProcessedStyle;
    var iconTextMergedClassNames = css(dataGridColumnProcessedStyle.fontProperties, dataGridColumnProcessedStyle.textColor, dataGridColumnProcessedStyle.leftAlignedCellContainer, props.className);
    return (React.createElement("div", { className: String(dataGridColumnProcessedStyle.leftAlignedCellContainer) },
        React.createElement("span", { className: iconTextMergedClassNames },
            icon && (React.createElement(FontIcon, { "data-testid": "DataGridColumnIconText", iconName: icon, className: String(dataGridColumnProcessedStyle.fontIcon) })),
            valueOrDefaultColumnRenderer(text))));
};
//# sourceMappingURL=DataGridColumnIconText.base.js.map